<template>
  <b-modal
    :id="id"
    ref="modal"
    size="lg"
    title="Add a New Panel"
    @shown="focusInput"
    @hidden="clearForm"
    ok-title="Submit"
    @ok="submit"
    :busy="processing"
  >
    <div class="position-relative">
      <b-form @submit.stop.prevent="submit">
        <b-form-group
          label="Describe the panel you want"
          label-for="new-panel-text"
        >
          <b-overlay :show="processing" rounded="sm" :opacity="0.2">
            <b-form-textarea
              id="new-panel-text"
              v-model="form.prompt"
              ref="promptInput"
              placeholder="Prompt..."
              rows="4"
              max-rows="8"
              required
            />
          </b-overlay>
        </b-form-group>
      </b-form>
      <PanelSuggestions @click="fillFromSuggested"></PanelSuggestions>
    </div>
  </b-modal>
</template>

<script>
import PanelEventBus from '@/xvisor/bus/PanelEventBus';
import PanelSuggestions from '@/xvisor/components/custom/PanelSuggestions.vue';

export default {
  components: {
    PanelSuggestions,
  },
  props: {
    id: {
      type: String,
      default: 'add-item-modal',
    },
    dashboardId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      form: {
        prompt: '',
      },
      processing: false,
    };
  },

  computed: {
    addPanelUrl() {
      return `/dashboards/${this.dashboardId}/panels/add`;
    },
  },

  methods: {
    show() { this.$refs.modal.show(); },
    hide() { this.$refs.modal.hide(); },
    clearForm() { this.form.prompt = ''; },

    fillFromSuggested(suggested) {
      this.clearForm();
      this.form.prompt = suggested;
    },

    focusInput() {
      // Auto‑focus when the modal opens
      this.$nextTick(() => {
        const input = this.$refs.promptInput;
        if (input) {
          input.focus();
        }
      });
    },

    submit(bvModalEvt) {
      // Stop modal from closing until we are ready (done processing)
      bvModalEvt.preventDefault();
      this.httpPost();
    },

    httpPost() {
      this.processing = true;
      this.$http
        .post(this.addPanelUrl, this.form)
        .then(() => {
          this.$bvToast.toast('Successfully added panel', { variant: 'success' });
          PanelEventBus.$emit('added');
          this.hide();
          this.clearForm();
        })
        .catch(() => {
          this.$bvToast.toast('Failed to add panel', { variant: 'danger' });
        }).finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>
